export enum LocContext {
  JOBS = "R0-JOBS",
  JOB = "R0-JOB",
  GENERAL = "R0-GENERAL",
  PROFILE = "R0-PROFILE",
  CV = "R0-CV",
  ADMIN = "R0-ADMIN",
  WORKSCHEDULE = "R0-WORKSCHEDULE",
}
